import React from 'react';
import { TextField, Link } from '@material-ui/core';

const PasswordField = ({ id, name, label, showPassword, onToggle, classes, ...textFieldProps }) => (
    <>
        <TextField
            id={id}
            name={name}
            label={label}
            type={showPassword ? 'text' : 'password'}
            variant="outlined"
            {...textFieldProps}
        />
        <Link
            color="secondary"
            underline="always"
            variant="subtitle2"
            className={classes.showPassword}
            onClick={onToggle}
        >
            {showPassword ? 'Hide Password' : 'Show Password'}
        </Link>
    </>
);

export default PasswordField;
